export default function () {
  return {
    lists: [],
    listsCount: 0,
    isListsLoading: false,
    search: null,
    listsImportedFromCsv: []
  }
}
